import React, { useState, createContext, useContext } from "react";
import { ConfigProvider } from "antd";

// Create a context for theme toggling
const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

const ThemeToggle = ({ children }) => {
  const [isDarkTheme, setIsDarkTheme] = useState(true);

  const toggleTheme = () => {
    setIsDarkTheme((prevTheme) => !prevTheme);
  };
  const lightTheme = {
    token: {
      colorPrimary: "#cf9c46",
      colorBgBase: "#ffffff",
      colorTextBase: "#000000",
    },
  };

  const darkTheme = {
    token: {
      colorPrimary: "#cf9c46",
      colorBgBase: "#1f1f1f",
      colorTextBase: "#ffffff",
    },
  };

  return (
    <ThemeContext.Provider value={{ isDarkTheme, toggleTheme }} >
      <ConfigProvider theme={isDarkTheme ? darkTheme : lightTheme}>
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeToggle;
